<template lang="pug">
.ticket-info
  h5(v-if="getTicketType.type === 'group'", style="margin-left: 32px; margin-bottom: 12px; color: #888;") 此票種報名人數需符合 {{ getTicketType.min }} - {{ getTicketType.max }} 人 (含隊長)
  h5(style="margin-left: 32px; color: #888;") {{ isDdiving(getTicketType.desc) }}
  .mb-4
  .buyers-wrap
    .buyer-info(:class="{'leader' : getTicketType.type === 'group'}")
      .title {{ getTicketType.type === 'group' ? '團長資訊' : '個人資訊' }}
      .input-row
        .input-wrap.col-xs-12.col-md-5
          label 帳號
          input(type="text", v-bind:value="leaderInfo.account", disabled)
        .input-wrap.col-xs-12.col-md-5(:class="{warning: leaderInfo.isEmailAuth === false}")
          label Email
          input(type="email", v-bind:value="leaderInfo.email", disabled)
          small(v-if="leaderInfo.isEmailAuth === false").warn 此Email尚未通過驗證，
           a.link-red(href="https://www.4gamers.com.tw/member/player") 前往驗證
      .input-row
        .input-wrap.col-xs-12.col-md-5
          label 身份證末四碼
          input.idNumber(type="text", v-model.trim.lazy="leaderInfo.idNumber", @keyup="checkValue", index="leader")
          small.warn * 外籍人士請提供護照末四碼
          small.warn * 注意：請正確填寫身分證後四碼，我們將以此資料為入場驗證資料
    transition-group(name="list")
      .buyer-info(v-if="getTicketType.type === 'group'", v-for="(buyer, index) in members", v-bind:key="index")
        .title 隊員 {{ index + 1 }}
          .btn.delete(@click="removeBuyer(index)")
           .fa.fa-times
            span.text 刪除隊員
        .input-row
          .input-wrap.col-xs-12.col-md-5(:class="{warning: buyer.isAdult === false}")
            label 帳號
            input(type="text", v-model.trim.lazy="buyer.account" disabled)
            small.warn(v-if="buyer.isAdult === false") 會員於活動期間未滿18歲，不可報名參加活動
          .input-wrap.col-xs-12.col-md-5(:class="{warning: buyer.isEmailAuth === false}")
            label Email
            input(type="email", v-model.trim.lazy="buyer.email", disabled)
            small.warn(v-if="buyer.isEmailAuth === false") 此Email尚未通過驗證，請提醒隊員前往 https://www.4gamers.com.tw/member/player 驗證
        .input-row
          .input-wrap.col-xs-12.col-md-5
            label 身份證末四碼
            input.idNumber(type="text", v-model.trim.lazy="buyer.idNumber", ref="idNumber", @keyup="checkValue(index)", :index="index")
            //- small.warn * 外籍人士請提供護照末四碼
            //- small.warn * 注意：請正確填寫身分證後四碼，我們將以此資料為入場驗證資料
  .row(v-if="getTicketType.type === 'group' && members.length < getTicketType.max - 1")
    .search-member.col-xs-12
      h3 新增隊員
      .input-wrap(:class="{'noResult': !ifResult}")
        .input-valid-wrap
          label 搜尋帳號
          input(type="text", @keyup="searchAccount($event.target.value)", @keyup.left.prevent="", @keyup.right.prevent="", v-model="searchInput")
          .status(v-if="this.searchInput.length > 0 && loading") 搜尋中...
          .btn.clear-button(v-if="this.searchInput.length > 0 && !loading", @click="clearResult") X
      ul.options-dropdown
        li(v-if="index < 5", v-for="(option, index) in options" @click="getSelected(option.account, option.email, option.is_adult, option.is_email_auth)")
          div.account {{ option.account }}
          div.email {{ option.email }}
  hr
  .btn-wrap
    .btn.ghost-btn.pre-btn(@click="$router.go(-1)") 上一步
    .btn.ghost-btn.next-btn(@click="submitInfo", :disabled="submitDisabled")
      .spinner(v-if="submitDisabled")
        span.text 處理中
        .bounce.bounce1
        .bounce.bounce2
        .bounce.bounce3
      span(v-else) 下一步
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  name: 'ticketInfo',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (!vm.getTicketType.type) {
        vm.$router.push({name: 'ticketType'})
      }
      if (vm.leaderInfo.isAdult === false) {
        vm.$swal({
          type: 'error',
          title: '未滿18歲',
          text: '您於活動期間未滿18歲，無法報名參加',
          confirmButtonText: '返回'
        }).then(() => {
          vm.$router.push({name: 'ticketType'})
        }, () => {
          vm.$router.push({name: 'ticketType'})
        })
      }
    })
  },
  props: {
  },
  data () {
    return {
      ticketType: '',
      leaderInfo: {
        account: '',
        idNumber: '',
        email: '',
        leader: true,
        isEmailAuth: Boolean,
        isAdult: Boolean
      },
      loading: false,
      ifResult: true,
      members: [],
      searchInput: '',
      options: [],
      selected: '',
      submitDisabled: false
    }
  },
  computed: {
    ...mapGetters([
      'getTicketType',
      'getTicketMembers',
      'getTicketGroup',
      'getUser'
    ])
  },
  mounted () {
    if (this.getTicketMembers.length > 0) {
      this.members = this.getTicketMembers
    }
    if (this.getTicketType.type) {
      this.leaderInfo.account = String(Object.assign(this.getUser.info.account))
      this.leaderInfo.email = String(Object.assign(this.getUser.info.email))
      this.leaderInfo.isEmailAuth = Boolean(Object.assign(this.getUser.info.is_email_auth))
      this.leaderInfo.isAdult = Boolean(Object.assign(this.getUser.info.is_adult))
    }
    // this.leaderInfo.account = this.getUser.info.account
    // this.leaderInfo.email = this.getUser.info.email
  },
  methods: {
    ...mapActions([
      'saveTicketsType',
      'saveTicketsGroup',
      'saveTicketsMembers',
      'queryMembers',
      'submitRegister',
      'fetchRegistered'
    ]),
    isDdiving (typeText) {
      let diving = typeText.indexOf('潛水')
      if (diving > -1) {
        return '潛水票限定在 “D區”劃位 。 WirForce 活動期間不會有廠商活動在該區進行。'
      } else {

      }
    },
    searchAccount: _.debounce(function (account) {
      this.loading = true
      if (this.searchInput !== '') {
        this.queryMembers(account).then((data) => {
          if (data !== null) {
            this.ifResult = true
            // console.log(data)
            if (this.members.length <= 0) {
              this.options = Object.keys(data).map((k) => data[k])
              this.loading = false
            } else {
              let searchResult = Object.keys(data).map((k) => data[k])
              const flatten = arr => arr.reduce((carry, item) => carry.concat(
                this.members.findIndex(x => x.account === item.account) === -1
                ? [item]
                : []
              ), [])
              // let afterReduce = searchResult.reduce((carry, item) => carry.concat(
              //   this.members.findIndex(x => x.account === item.account) === -1
              //   ? [item]
              //   : []
              // ), [])
              this.options = flatten(searchResult)
              this.loading = false
            }
          } else {
            this.options = []
            this.ifResult = false
            this.loading = false
          }
        }, (err) => {
          if (err.type === 'member_not_found') {
            this.options = []
            this.ifResult = false
            this.loading = false
          }
        })
      } else {
        this.options = []
        this.ifResult = false
        this.clearResult()
      }
    }, 300),
    getSelected (account, email, isAdult, isEmailAuth) {
      // console.log(account, email)
      this.selected = {account, email, isAdult, isEmailAuth}
      this.AddToMembers()
    },
    AddToMembers () {
      // console.log(this.selected)
      this.members.push(this.selected)
      this.clearResult()
    },
    clearResult () {
      this.options = []
      this.selected = this.searchInput = ''
      this.ifResult = true
    },
    AddBuyer () {
      this.members.push({
        account: '',
        idNumber: '',
        email: ''
      })
    },
    checkValue () {
      let val = event.target.value
      let target = event.currentTarget
      // let index = target.getAttribute('index')
      if (val.length > 4) {
        let final = val.substring(0, 4)
        event.target.value = final
      }
      const number = new RegExp('[0-9]{4,4}')
      let valid = number.test(val)
      if (valid) {
        // console.log(index + ': ', valid)
        target.classList.remove('hasChange')
        target.classList.add('valided')
        return true
      } else {
        target.classList.remove('valided')
        target.classList.add('hasChange')
        return false
      }
    },
    allValided () {
      let target = document.getElementsByClassName('idNumber')
      const number = new RegExp('[0-9]{4,4}')
      for (var i = 0; i < target.length; i++) {
        let num = target[i].value
        let valid = number.test(num)
        if (num.length !== 4) {
          return false
        }
        if (!valid) {
          return false
        }
      }
      return true
    },
    submitInfo () {
      let submitForm = []
      Object.assign(submitForm, this.members)
      submitForm.unshift(this.leaderInfo)
      // console.log('allValided: ', this.allValided())
      console.log(this.members.length, this.getTicketType.min)
      if (this.submitDisabled === false) {
        this.submitDisabled = true
        if (this.allValided() === true) {
          if (this.getTicketType.type === 'group' && this.members.length < this.getTicketType.min - 1) {
            this.$swal({
              title: '人數不足',
              text: '隊長+隊員需為 ' + this.getTicketType.min + ' 人至' + this.getTicketType.max + '人',
              type: 'error',
              confirmButtonText: '關閉'
            }).then((res) => {
              this.submitDisabled = false
            })
          } else if (submitForm.length <= 1 && this.getTicketType.type === 'group') {
            this.$swal({
              title: '說好的隊友呢？',
              text: '請先新增隊友並填入身份證末四碼',
              type: 'error',
              // showCancelButton: true,
              confirmButtonText: '關閉'
            }).then((res) => {
              this.submitDisabled = false
            })
          } else {
            // console.log('submitForm: ', submitForm)
            // console.log('getTicketType: ', this.getTicketType)
            let params = {
              ticketType: this.getTicketType.type,
              ticketId: this.getTicketType.ticketId,
              account: [],
              id_number: []
            }
            if (this.getTicketType.type === 'single') {
              params.id_number = submitForm[0].idNumber
              this.submitRegister(params).then((res) => {
                console.log('single-res:', res)
                // 成功發送
                let counter = 30
                let ifRegister = setInterval(() => {
                  this.fetchRegistered().then((res) => {
                    console.log('ifRegistered res')
                    clearInterval(ifRegister)
                    this.$router.push({name: 'ticketSuccess'})
                  }, (err) => {
                    if (err.type === 'order_data_processing') {
                      if (counter === 0) {
                        clearInterval(ifRegister)
                        this.$swal({
                          title: '發送逾時',
                          text: '您的網路不穩，請稍後重新嘗試',
                          type: 'error'
                        })
                        this.submitDisabled = false
                      }
                      counter--
                      console.log('counter:' + counter)
                      console.log('ifRegistered err')
                    }
                  })
                }, 500)
              }, (err) => {
                console.log('single-err:', err)
                if (err.error.data) {
                  if (typeof err.error.data.age !== 'undefined' && err.error.data.age.length > 0) {
                    this.$swal({
                      title: '未達年齡限制',
                      text: '年齡未滿18歲，如有帳號生日錯誤，請與客服聯絡',
                      type: 'info'
                    }).then((res) => {
                      this.submitDisabled = false
                    })
                  }
                  if (typeof err.error.data.email !== 'undefined' && err.error.data.email.length > 0) {
                    this.$swal({
                      title: 'Email未驗證',
                      text: '請至4Gamers官網驗證您的Email',
                      type: 'info'
                    }).then((res) => {
                      this.submitDisabled = false
                    })
                  }
                  if (typeof err.error.data.on_register !== 'undefined' && err.error.data.on_register.length > 0) {
                    this.$swal({
                      title: '重複報名',
                      text: '你已經報名過了，請至個人頁面察看票卷',
                      confirmButtonText: '前往察看',
                      type: 'info'
                    }).then((res) => {
                      this.submitDisabled = false
                      this.$router.push({name: 'user'})
                    })
                  }
                  if (typeof err.error.data.remain_ticket_count !== 'undefined') {
                    this.$swal({
                      title: '票券不足',
                      text: err.error.data.ticket_title + '數量不足囉！請選擇其他票種',
                      type: 'info'
                    }).then((res) => {
                      this.submitDisabled = false
                      this.$router.push({name: 'ticketType'})
                    })
                  }
                }
              })
              // console.log('submit: single', params)
            }
            if (this.getTicketType.type === 'group') {
              for (let i = 0; i < submitForm.length; i++) {
                params.id_number.push(submitForm[i].idNumber)
                params.account.push(submitForm[i].account)
              }
              this.submitRegister(params).then((res) => {
                console.log('group-res:', res)
                // 成功發送
                let counter = 30
                let ifRegister = setInterval(() => {
                  this.fetchRegistered().then((res) => {
                    console.log('ifRegistered res')
                    clearInterval(ifRegister)
                    this.$router.push({name: 'ticketSuccess'})
                  }, (err) => {
                    if (err.type === 'order_data_processing') {
                      if (counter === 0) {
                        clearInterval(ifRegister)
                        this.$swal({
                          title: '發送逾時',
                          text: '您的網路不穩，請稍後重新嘗試',
                          type: 'error'
                        })
                        this.submitDisabled = false
                      }
                      counter--
                      console.log('counter:' + counter)
                      console.log('ifRegistered err')
                    }
                  })
                }, 500)
              }, (err) => {
                console.log('group-err:', err)
                if (err.error.data) {
                  if (typeof err.error.data.age !== 'undefined' && err.error.data.age.length > 0) {
                    this.$swal({
                      title: '未達年齡限制',
                      text: err.error.data.age + '年齡未滿18歲，如為帳號生日錯誤，請與客服聯絡',
                      type: 'info'
                    }).then((res) => {
                      this.submitDisabled = false
                    })
                  }
                  if (typeof err.error.data.email !== 'undefined' && err.error.data.email.length > 0) {
                    this.$swal({
                      title: 'Email未驗證',
                      text: '請至4Gamers官網驗證' + err.error.data.email + '的Email',
                      type: 'info'
                    }).then((res) => {
                      this.submitDisabled = false
                    })
                  }
                  if (typeof err.error.data.on_register !== 'undefined' && err.error.data.on_register.length > 0) {
                    this.$swal({
                      title: '重複報名',
                      text: err.error.data.on_register + ' 已經報名過了，請確認您與團員報名狀態',
                      type: 'info'
                    }).then((res) => {
                      this.submitDisabled = false
                    })
                  }
                  if (typeof err.error.data.remain_ticket_count !== 'undefined') {
                    this.$swal({
                      title: '票券不足',
                      text: err.error.data.ticket_title + '數量不足囉！請選擇其他票種',
                      type: 'info'
                    }).then((res) => {
                      this.submitDisabled = false
                      this.$router.push({name: 'ticketType'})
                    })
                  }
                }
              })
              // console.log('submit: group', params)
            }
          }
        } else {
          this.$swal({
            title: '請確認「身份證」皆正確填寫',
            text: '身份證需為四位數字',
            type: 'error',
            confirmButtonText: '關閉'
          }).then((res) => {
            this.submitDisabled = false
          })
        }
      }
    },
    removeBuyer (index) {
      this.$delete(this.members, index, {
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/mixin'
@import '~stylesheets/components'
.buyers-wrap
  .buyer-info
    padding-bottom: 32px
    margin-bottom: 48px
    &:not(:last-child)
      // border-bottom: 1px solid $grey
      +transition(all, 0.3s, ease)
    @extend %clearfix
    .title
      font-size: 18px
      font-weight: bold
      margin-bottom: 16px
      .btn.delete
        position: relative
        margin-left: 24px
        border: none
        padding: 0
        background-color:#fff
        color: $black
        padding-right: 8px
        +border-radius(0)
        .text
          float: left
          display: block
          text-indent: -60px
          overflow: hidden
          padding: 0 3px
          color: $black
          font-weight: bold
          opacity: 0
          +transition(all, 0.3s, ease)
        &:before
          content: ''
          position: absolute
          left: -10px
          width: 0
          height: 0
          border-style: solid
          border-width: 10px 10px 10px 0
          border-color: transparent #fff transparent transparent
          display: block
        &:hover
          .text
            opacity: 1
            text-indent: 0
    &.leader
      border-bottom: 1px solid $grey

.search-member
  padding: 16px 32px 64px 32px
  margin-bottom: 48px
  background-color: rgba(#000, 0.3)
  h3
    margin-bottom: 32px
  .input-wrap
    float: none
    .input-valid-wrap
      display: inline-block
      position: relative
      .status
        right: 8px
        position: absolute
        top: 8px
        color: #fff
      .btn.clear-button
        right: 0
        position: absolute
        color: #fff
        border: 1px solid $grey
      @media screen and (max-width: 640px)
        width: 100%
    &.noResult
      .input-valid-wrap
        input
          border-color: $red
          &:focus
            outline-color: $red
        .btn.clear-button
          color: $red
          border-color: $red
        &:after
          position: absolute
          top: -20px
          right: -2px
          content: '查無帳號'
          color: $red
          display: block
          @media screen and (max-width: 990px)
            top: 0px
  .options-dropdown
    list-style: none
    display: block
    margin: 0
    padding: 0
    li
      float: left
      border: 1px solid #fff
      background-color: $black
      padding: 6px 8px
      margin: 6px
      border-radius: 3px
      cursor: pointer
      @media screen and (max-width: 990px)
        width: 100%
      .account
        font-weight: bold
        font-size: 13px
        margin-bottom: 3px
      .email
        font-size: 12px
      &:hover
        background-color: #fff
        .account
          color: $black
        .email
          color: $black

.input-wrap
  float: left
  color: $grey
  margin: 8px 0
  padding: 0 8px
  label
    text-align: left
    margin-right: 16px
    width: 100px
    @media screen and (max-width: 640px)
      display: block
  input
    min-width: 260px
    background:
      // color: transparent
      color: $black
    border: 1px solid $grey
    color: #fff
    padding: 6px 12px
    &.hasChange
      border-color: $red
      outline: none
    &.valided
      background-color: rgba(#000, 0.3)
      outline: none
      border-color: $green
    @media screen and (max-width: 990px)
      width: 100%
    &:disabled
      border: none
      background-color: rgba(#000, 0.3)
  &.warning
    label
      color: $red
    input
      border: 1px solid $red
.warn
  color: $red
  display: block
  margin-top: 8px
  .link-red
    color: #ff9400
    &:hover
      color: #ff9400
</style>



// WEBPACK FOOTER //
// ticketInfo.vue?c5eb7046